import { COOKIE_NAME, TTL_DAYS } from './const';

/**
 * Формат — один на оба конца (`Romantic\Tool\Ab\VisitorId::normalize()`):
 * 32 hex-символа. Послабление на одном конце, до которого другой не дотянется,
 * — мёртвый код, читающийся как рабочий.
 */
const VISITOR_ID_RE = /^[a-f0-9]{32}$/;

export const isVisitorIdValid = (id: unknown): id is string =>
    typeof id === 'string' && VISITOR_ID_RE.test(id);

export const normalizeVisitorId = (raw: string): string => {
    const id = raw.trim().toLowerCase();

    return VISITOR_ID_RE.test(id) ? id : '';
};

/**
 * Значение куки или '' — «нет» и «есть, но негодное» здесь одно и то же: у
 * этого id нет надгробия логаута, в отличие от токена владения, поэтому
 * различать их незачем.
 *
 * Значение НЕ раскодируется намеренно: годный id состоит из hex-символов, а их
 * процентное кодирование не трогает. Значит decodeURIComponent мог бы только
 * бросить URIError на одиноком `%` — на функции, которая зовётся первой на
 * каждой странице и унесла бы с собой весь бутстрап.
 */
export const readVisitorIdCookie = (cookieString: string): string => {
    const match = new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`).exec(
        cookieString || ''
    );

    return match ? normalizeVisitorId(match[1]) : '';
};

export const buildCookie = (id: string, isHttps: boolean): string =>
    `${COOKIE_NAME}=${id};path=/;max-age=${TTL_DAYS * 86400};SameSite=Lax` +
    (isHttps ? ';Secure' : '');

/**
 * 16 случайных байт в hex.
 *
 * `crypto` есть везде, где нам важно (для getRandomValues защищённый контекст
 * не нужен — его требует только `crypto.subtle`), но запасной путь оставлен:
 * от качества случайности тут зависит равномерность вёдер, а не секрет, так что
 * Math.random в роли фолбэка честнее исключения на каждой странице.
 */
export const mintVisitorId = (): string => {
    const bytes = new Uint8Array(16);

    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        crypto.getRandomValues(bytes);
    } else {
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = Math.floor(Math.random() * 256);
        }
    }

    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};
